export class KioskConfiguration {
	pk: string; //:venueKey
	sk: string; //kiosk_configuration_{kioskLicenseKey}
	deviceLicenseKey: string;
	menuKey: string;
	paymentDevice: string;
	paymentDeviceIpAddress: string;
	paymentDeviceKey: string;
	kioskName: string;
	availability: KioskMenuAvailability[];
	orderTypeKeys: number[];

	public constructor(init?: Partial<KioskConfiguration>) {
		Object.assign(this, init);
	}
}

export class KioskMenuAvailability {
	timeRangeKey: string;
	menuKey: string;

	public constructor(init?: Partial<KioskMenuAvailability>) {
		Object.assign(this, init);
	}
}
